import { assign } from "lodash";
import { ChangeDetectionStrategy, Component, ElementRef, signal, ViewChild } from "@angular/core";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from "@medsurf/flat-facades";
import { ZodSharedValidator } from "@medsurf/flat-validators";

@Component({
    selector: 'medsurf-slide-edit-group',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.scss'],
    standalone: false
})
export class GroupComponent {
  @ViewChild('edit_overlay_template_scroll_panel', {static: false}) editPanelScrollPanel: ElementRef<HTMLDivElement>;
  
  #isSubmitted = signal(false);
  group: FlatModels.GroupEntityModels.Group | null;
  groupForm = new FormGroup(
    {
      name: new FormControl(''),
      color: new FormControl(''),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.GroupEntityModels.GroupSchema.pick({
          name: true,
          color: true,
        })
      ),
      updateOn: 'change'
    }
  );
  readonly FlatModels = FlatModels;
  
  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Group
    this.slideAuthorFacade.currentSelectedSlideGroup$.pipe(takeUntilDestroyed()).subscribe((group) => {
      if (this.group?.id !== group?.id && this.editPanelScrollPanel) {
        this.editPanelScrollPanel.nativeElement.scrollTop = 0;
      }
      this.group = structuredClone(group);
      if (this.group) {
        this.groupForm.reset(this.group);
      }
      this.#isSubmitted.set(false);
    });
  }
  
  onSubmit() {
    if (this.#isSubmitted() || this.groupForm.invalid) {
      return;
    }
    this.#isSubmitted.set(true);
    
    // Update Group
    const group = assign(this.group, this.groupForm.value);
    this.slideAuthorFacade.requestUpdateGroup(group, 'history.annotation_group_update').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.groupForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
}
